<template>
  <div class="w-100">
    <label>Tipo de Relatório</label>
    <select class="form-control custom-select" v-model="report">
      <option v-for="item,i in types" :key="i" :value="item.id">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      report: 'Sell',
      types: [
        // { id: 'student', name: 'Alunos'},
        { id: 'Sell', name: 'Vendas'},
        // { id: 'course', name: 'Cursos'},
      ]
    }
  }
}
</script>
